import React, { createContext, FC, useContext, useEffect, useState } from 'react';

import { useGlobalBlueprintProtoContext } from '@lib/providers/blueprint-proto';
import { ProtoData } from '@lib/providers/blueprint-version';
import { csInboxService } from '@lib/services/cstool';
import { BlueprintProto, InboxVersion } from '@lib/services/models';

const useInboxContextValue = (version: InboxVersion) => {
  const { protoMap: globalProtos } = useGlobalBlueprintProtoContext();

  const [blueprint, setBlueprint] = useState<BlueprintProto>();
  const [protos, setProtos] = useState<ProtoData>();

  const loadProto = async () => {
    const res = await csInboxService.getMessageProto(version);
    if (res.ok) {
      setBlueprint(res.data?.messageBlueprint);

      setProtos(
        (res.data?.extraProtos ?? []).reduce<ProtoData>((all, item) => {
          all[item.name] = item.proto as any;
          return all;
        }, globalProtos),
      );
    }
  };

  useEffect(() => {
    loadProto();
  }, []);

  return {
    version,
    blueprint,
    protos,
  };
};

export type InboxContextValue = ReturnType<typeof useInboxContextValue>;

const inboxContext = createContext<InboxContextValue | null>(null);
const { Provider } = inboxContext;

export const InboxV1Provider: FC = ({ children }) => {
  const value = useInboxContextValue(InboxVersion.V1);

  return <Provider value={value}>{children}</Provider>;
};

export const InboxV2Provider: FC = ({ children }) => {
  const value = useInboxContextValue(InboxVersion.V2);

  return <Provider value={value}>{children}</Provider>;
};
export const InboxV3Provider: FC = ({ children }) => {
  const value = useInboxContextValue(InboxVersion.V3);

  return <Provider value={value}>{children}</Provider>;
};

export const useInboxContext = () => {
  const ctx = useContext(inboxContext);
  if (!ctx) {
    throw new Error('useInboxContext must be used inside InboxProvider');
  }

  return ctx;
};

export default InboxV1Provider;
